<template lang="pug">
nav.b-main-menu.navbar.navbar-expand-lg.navbar-light
    router-link._logo.navbar-brand.header-2.me-4(to="/") Connections

    section.d-flex.flex-row.ms-auto
        button.btn.btn-link.d-flex.d-lg-none(
            type="button",
            @click="$store.commit('setFilterSidebarState', true)"
            v-if="showFilterButton"
        )
            span.icon.icon--filter.bg--transparent

        button.btn.btn-link.d-flex(
            type="button",
            @click="isSearchInputOpen = !isSearchInputOpen"
        )
            span.icon.icon--search.bg--transparent

        button.btn.btn-link.d-flex.d-md-none(
            type="button",
            @click="$store.commit('setFeedSidebarState', true)"
        )
            span.icon.icon--list.bg--transparent

    #menuSearch.search-wrapper
        SearchInput(
            :isOpen="isSearchInputOpen",
            @change="handleSearchInputChange",
            @close="isSearchInputOpen = false"
        )
</template>

<script>
import { mapMutations } from "vuex";
import SearchInput from "@/components/SearchInput.vue";

export default {
    name: "PageHeaderComponent",
    components: { SearchInput },
    data: () => ({
        showFilterButton: true,
    }),
    computed: {
        isSearchInputOpen: {
            get() {
                return this.$store.state.searchInputOpen;
            },
            set(val) {
                return this.setSearchInputOpen(val);
            },
        },
    },
    methods: {
        ...mapMutations([
            "setSearchQuery",
            "setFilterQuery",
            "setSearchInputOpen",
        ]),
        handleSearchInputChange(query) {
            this.setFilterQuery(null);
            this.setSearchQuery(query);
        },
    },
    watch: {
        $route(to) {
            this.showFilterButton = to.name === "home";
        },
    },
};
</script>
